const KL_ACCORDION_SUMMARY_SELECTOR = '[data-kl-accordion-summary]';
const KL_ACCORDION_DRIFT_TOLERANCE = 1;
const KL_ACCORDION_CORRECTION_PASSES = 1;

function getScrollCorrection(topBefore, topAfter) {
  return topAfter - topBefore;
}

function scrollPageBy(offset) {
  const scrollingElement = document.scrollingElement;

  if (!scrollingElement) return;

  scrollingElement.scrollTop += offset;
}

function correctDrift(summaryElement, topBefore, passesLeft) {
  try {
    const topAfter = summaryElement.getBoundingClientRect().top;
    const correction = getScrollCorrection(topBefore, topAfter);

    if (Math.abs(correction) < KL_ACCORDION_DRIFT_TOLERANCE) return;

    scrollPageBy(correction);

    if (passesLeft <= 0) return;

    requestAnimationFrame(() => correctDrift(summaryElement, topBefore, passesLeft - 1));
  } catch (error) {
    console.debug('kl-accordion-anchor: the row could not be held still', { error });
  }
}

function handleDocumentClick(event) {
  try {
    const targetElement = event.target;

    if (!targetElement || typeof targetElement.closest !== 'function') return;

    const summaryElement = targetElement.closest(KL_ACCORDION_SUMMARY_SELECTOR);

    if (!summaryElement) return;

    const topBefore = summaryElement.getBoundingClientRect().top;
    requestAnimationFrame(() => correctDrift(summaryElement, topBefore, KL_ACCORDION_CORRECTION_PASSES));
  } catch (error) {
    console.debug('kl-accordion-anchor: the pressed row could not be measured', { error });
  }
}

document.addEventListener('click', handleDocumentClick);
